import apiClient from '@u/apiClient'

export default {
  //region fetch
  fetchStatIndex({ commit }) {
    apiClient
      .get('api/stats/metadata')
      .then(async (response) => {
        await commit('setStatMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchNoteIndex', reason)
      })
  },
  fetchStatsBlockData({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    return apiClient.post(`api/stats/fetch-data`, payload).then((response) => {
      commit('setStatsBlockData', { index: payload.index, data: response.data })
      return response.data
    })
  },
  async exportStatsBlockDataToExcel({ commit }, payload) {
    console.log('exportStatsBlockDataToExcel', payload)
    commit('auth/setErrors', {}, { root: true })
    await apiClient
      .post(`api/stats/fetch-data?action=${payload.action}`, payload)
      .then(async (response) => {
        window.open(response.data.url)
      })
      .catch(async (reason) => {
        console.error('fetchStatsBlockData', reason)
      })
  },

  // async fetchNoteById({commit}, payload) {
  //     await apiClient.get(`api/note/${payload.id}`)
  //         .then(async response => {
  //             commit('setNote', response.data.note)
  //             commit('setNoteMetadata', response.data.metadata)
  //         })
  //         .catch(async reason => {
  //             console.error('fetchNoteById', reason)
  //         })
  // },
  //endregion

  //region store
  storeNote({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    return apiClient.post('api/note', payload.note).then((response) => {
      commit('setNotesIndex', response.data.notes)
      return response.data
    })
  },
  //endregion

  //region update
  updateNote({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    return apiClient
      .put(`api/note/${payload.note.id}`, payload.note)
      .then((response) => {
        commit('setNotesIndex', response.data.notes)
        return response.data
      })
  }
  //endregion
}
